/**
 * Global fetch interceptor om 403 errors af te vangen en te redirecten naar access-denied pagina
 */

// Bewaar de originele fetch
const originalFetch = window.fetch;

// Override window.fetch
window.fetch = async (...args) => {
    const response = await originalFetch(...args);
    
    // Als we een 403 krijgen, check of het een tenant error is
    if (response.status === 403) {
        const contentType = response.headers.get('content-type');
        
        // Alleen JSON responses van onze eigen API afvangen
        if (contentType?.includes('application/json')) {
            try {
                const clone = response.clone(); // Clone omdat we de body maar 1x kunnen lezen
                const data = await clone.json();
                
                // Check of het een tenant error is
                if (data.error === 'TENANT_NOT_FOUND' || data.error === 'TENANT_BLOCKED') {
                    // Redirect naar access-denied pagina met error info
                    const params = new URLSearchParams({
                        error: data.error,
                        ...(data.tenantId && { tenantId: data.tenantId })
                    });
                    
                    window.location.href = `/#/access-denied?${params.toString()}`;
                }
            } catch (e) {
                // Als het geen JSON is of parsing faalt, gewoon de originele response returnen
                console.error('Error parsing 403 response:', e);
            }
        }
    }
    
    return response;
};

export {};
